// ======================================================================
// File Name       : ChatContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { reduxForm, isInvalid, getFormValues, formValueSelector } from 'redux-form';
import * as MessageThreadAction from '../../actions/MessageThreadAction';
import ChatInfo from '../../components/messageThread/ChatInfo';
import ChatBubbles from '../../components/messageThread/ChatBubbles';
import ChatForm from '../../components/messageThread/ChatForm';
import { MODE, LO_SUPER_USER, SUPER_USER, STRUCTURE_LEVEL, SUPER_USER_SECERN_ID } from '../../constants/index';
import { MESSAGE_TYPE, MESSAGE_FILTER } from '../../constants/MessageThreadContants';
import * as Path from '../../constants/PathConstants';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { showLoading, hideLoading, checkAuthorSuperuser } from '../../utils/PageUtils';


class ChatContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: false,
      loadMoreFinish: false,
      messageInfo: {},
      pageNum: 0,
      isSending: false,
    };
    this.initData = this.initData.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.goBack = this.goBack.bind(this);
    this.createParam = this.createParam.bind(this);
    this.getNewMessage = this.getNewMessage.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.downloadAttachment = this.downloadAttachment.bind(this);
    this.deleteMyMessage = this.deleteMyMessage.bind(this);
    this.onDeleteDialogOk = this.onDeleteDialogOk.bind(this);
    this.onDeleteDialogCancel = this.onDeleteDialogCancel.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    const rootMessageIdAuto = match.params.messageRootId;
    const userSecernId = match.params.userSecernId;
    if (!rootMessageIdAuto || !userSecernId) {
      this.props.history.goBack();
      return;
    }
    this.initData(rootMessageIdAuto, userSecernId);
  }

  // Step 10.0.0 START
  componentWillUnmount() {
    this.props.dispatch(MessageThreadAction.resetData());
  }
  // Step 10.0.0 END

  initData(targetRootMessageIdAuto, userSecernId) {
    const param = {
      targetRootMessageIdAuto,
      userSecernId,
      recursiveType: STRUCTURE_LEVEL.ALL,
    };
    this.props.initialize({
      userSecernId,
      rootMessageIdAuto: targetRootMessageIdAuto,
      parentMessageIdAuto: targetRootMessageIdAuto,
    });
    this.props.dispatch(MessageThreadAction.getInitDataForChat(param));
  }

  getNewMessage() {
    const { formValues } = this.props;
    if (!formValues) {
      return;
    }
    const paramRootMessage = {};
    paramRootMessage.targetRootMessageIdAuto = formValues.rootMessageIdAuto;
    paramRootMessage.userSecernId = formValues.userSecernId;
    paramRootMessage.recursiveType = STRUCTURE_LEVEL.ALL;
    this.setState({
      pageNum: 0,
    }, () => {
      this.props.dispatch(MessageThreadAction.getMessageStructure(paramRootMessage));
    });
  }

  loadMore() {
    this.props.dispatch(showLoading());
    this.setState(prevState => ({
      loadMoreFinish: false,
      pageNum: prevState.pageNum + 1,
    }), () => {
      this.props.dispatch(MessageThreadAction.loadMoreMessage()).then(() => {
        this.props.dispatch(hideLoading());
        this.setState({ loadMoreFinish: true });
      });
    });
  }

  sendMessage() {
    const { formValues, structureList } = this.props;
    const { isSending } = this.state;
    if (!formValues || !structureList || !structureList.length) {
      return;
    }
    const lastMessage = structureList[structureList.length - 1];
    const param = this.createParam(formValues, lastMessage);
    if (!isSending) {
      this.setState({ isSending: true }, () => {
        this.props
        .dispatch(
          MessageThreadAction.sendMessage(
            param,
            formValues.rootMessageIdAuto,
            formValues.userSecernId,
          ),
        )
        .then(() => {
          this.setState({ isSending: false });
          const id = 'attachmentFile';
          $(`#${id}`).val('');
          this.props.reset();
        })
        .catch(() => {
          this.setState({ isSending: false });
        });
      });
    }
  }

  createParam(formValues, lastMessage) {
    const param = {};
    param.editType = MODE.NEW_MODE;
    const messageInfo = {};
    messageInfo.messageType = MESSAGE_TYPE.SUB;
    messageInfo.messageContent = formValues.messageContent;
    messageInfo.parentMessageType = lastMessage.messageType;
    messageInfo.userSecernId = formValues.userSecernId;
    messageInfo.parentMessageIdAuto = lastMessage.messageIdAuto;
    param.messageInfo = messageInfo;
    formValues.attachmentFile &&
      formValues.attachmentFile.length &&
      (param.attachmentFile = formValues.attachmentFile[0]);
    formValues.edittingUserList && (param.edittingUserList = formValues.edittingUserList);
    return param;
  }

  downloadAttachment(item) {
    if (item && Object.keys(item).length) {
      if (isNaN(parseInt(item.messageType, 10)) || !item.messageIdAuto) {
        return;
      }
      const param = {};
      param.messageType = item.messageType;
      param.messageIdAuto = item.messageIdAuto;
      this.props.dispatch(MessageThreadAction.downloadMessageAttachment(param));
    }
  }

  deleteMyMessage(messageInfo, representationUserSecernId) {
    if (!messageInfo || messageInfo.messageType === MESSAGE_TYPE.ROUTE) {
      return;
    }
    const { userSecernId, displayUserType } = this.props.userInfo;
    const superUser = [LO_SUPER_USER, SUPER_USER].indexOf(displayUserType) > -1;
    // Step10.0.0 START
    if (
      userSecernId === messageInfo.authorSecernId
      || checkAuthorSuperuser(messageInfo.authorSecernId, superUser, representationUserSecernId)
    ) {
      this.setState({
        showDeleteModal: true,
        messageInfo,
      });
    }
    // Step10.0.0 END
  }

  onDeleteDialogOk() {
    const { messageInfo } = { ...this.state };
    const param = {
      paramMessageInfo: {
        editType: MODE.DELETE_MODE,
        messageInfo: {
          messageIdAuto: messageInfo.messageIdAuto,
          messageType: messageInfo.messageType,
        },
      },
    };
    this.setState(
      {
        showDeleteModal: false,
        messageInfo: {},
      },
      () => {
        this.props.dispatch(MessageThreadAction.deleteMessageThread(param)).then((error) => {
          if (!error) {
            this.props.dispatch(MessageThreadAction.reloadChatAfterDelete(messageInfo));
          }
        });
      },
    );
  }

  onDeleteDialogCancel() {
    this.setState({
      showDeleteModal: false,
      messageInfo: {},
    });
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const {
      rootMessageInfo: {
        messageTitle,
        messageContent,
        attachmentFileName,
        messageType,
        messageIdAuto,
      },
      structure,
      structureList,
      formValues,
      userInfo,
      filteredStructureRecordNum,
      structureRecordNum,
      isLoadMore,
      isDelete,
      contentMessage,
      reloadChat,
      representationUserSecernId,
    } = this.props;
    const { isSending } = this.state;
    const mySecernId = userInfo.userSecernId;
    const superUser = [LO_SUPER_USER, SUPER_USER].indexOf(userInfo.displayUserType) > -1;
    let fileName = '';
    let fileSize = 0;
    if (formValues && formValues.attachmentFile && formValues.attachmentFile.length) {
      fileName = formValues.attachmentFile[0].name;
      fileSize = formValues.attachmentFile[0].size;
    }
    return (
      <div>
        <ChatInfo
          messageTitle={messageTitle}
          messageType={messageType}
          messageIdAuto={messageIdAuto}
          messageContent={messageContent}
          attachmentFileName={attachmentFileName}
          getNewMessage={this.getNewMessage}
          downloadAttachment={this.downloadAttachment}
          goBack={this.goBack}
        />
        <ChatBubbles
          structureList={structureList}
          mySecernId={mySecernId}
          loadMore={this.loadMore}
          filteredStructureRecordNum={filteredStructureRecordNum}
          isLoadMore={isLoadMore}
          isDelete={isDelete}
          downloadAttachment={this.downloadAttachment}
          deleteMyMessage={this.deleteMyMessage}
          superUser={superUser}
          loadMoreFinish={this.state.loadMoreFinish}
          pageNum={this.state.pageNum}
          reloadChat={reloadChat}
          representationUserSecernId={representationUserSecernId}
        />
        <hr className="col-sm-12 padding-clear bold-hr" />
        <ChatForm
          {...this.props}
          fileName={fileName}
          fileSize={fileSize}
          sendMessage={this.sendMessage}
          goBack={this.goBack}
          contentMessage={contentMessage}
          isSending={isSending}
        />
        <DialogConfirm
          showModal={this.state.showDeleteModal}
          onCancel={this.onDeleteDialogCancel}
          content={MessageTemplate.MSG_DEL_MESSAGE_THREAD}
          onOK={this.onDeleteDialogOk}
        />
      </div>
    );
  }
}

const selector = formValueSelector('chatForm');
const mapStateToProps = (state, ownProps) => {
  const {
    rootMessageInfo,
    structure,
    filteredStructureRecordNum,
    structureRecordNum,
    structureList,
    isLoadMore,
    isDelete,
    reloadChat,
  } = state.messageThread;
  const { parentPath, searchCondition } = state.page;
  const { authedUser: { userInfo } } = state.authed;
  const { representationUserSecernId } = userInfo;
  return {
    rootMessageInfo,
    structure,
    structureList,
    filteredStructureRecordNum,
    structureRecordNum,
    userInfo,
    isLoadMore,
    isDelete,
    formValues: getFormValues('chatForm')(state),
    contentMessage: selector(state, 'messageContent'),
    reloadChat,
    representationUserSecernId,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'chatForm',
    touchOnChange: true,
  })(ChatContainer),
);
